
/* ============================================================
   LiqVits Quiz — Shopify-Section-Version.
   Liest alle veränderlichen Werte aus window.LV_QUIZ_CONFIG,
   das die Liquid-Section direkt vor dieser Datei ausgibt.
   ============================================================ */
const LVCFG = window.LV_QUIZ_CONFIG || {};
const IMG_LEMON     = (LVCFG.images && LVCFG.images.vitaminsFlavor1) || '';
const IMG_PEACH     = (LVCFG.images && LVCFG.images.vitaminsFlavor2) || '';
const IMG_WILDBERRY = (LVCFG.images && LVCFG.images.mineralsFlavor1) || '';
const IMG_CHERRY    = (LVCFG.images && LVCFG.images.mineralsFlavor2) || '';
const STARTER_SET_URL = LVCFG.urls?.starterSet || "https://laqvits.com/products/starter-set";
const VITAMINS_URL    = LVCFG.urls?.vitamins    || "https://laqvits.com/products/everyday-vitamins-ice-tea-lemon";
const MINERALS_URL    = LVCFG.urls?.minerals    || "https://laqvits.com/products/everyday-minerals-cherry";
const SHOW_BIOTICS = !!LVCFG.showBiotics;

/* Echte LiqVits Website-Claims — als Baustein für die "Top 3 Unterstützung".
   WICHTIG: Everyday Minerals enthält laut Zutatenliste NUR Eisen, Zink, Mangan,
   Kupfer, Iod, Selen, Molybdän & Chrom — KEIN Magnesium, KEIN Kalium/Calcium.
   Alle Texte unten sind entsprechend geprüft. */
const CLAIMS = {
  vitamins: [
    'LiqVits liefert Dir alle 13 Vitamine in einer täglichen Portion – flüssig und hochbioverfügbar.',
    'Dein Körper nimmt Nährstoffe flüssig deutlich besser auf: Bei Tabletten kommen im Schnitt nur ca. 20% überhaupt an.',
    'Zuckerfrei, kalorienfrei und schmeckt 1:1 wie Dein Lieblings-Softdrink.'
  ],
  minerals: [
    'LiqVits liefert Dir alle 8 essenziellen Mineralien – inkl. Eisen, Zink & Kupfer – in einer täglichen Portion.',
    'Flüssige Mineralstoffe verlassen den Magen in wenigen Minuten und werden dadurch spürbar besser aufgenommen als aus Tabletten.',
    'Zuckerfrei, kalorienfrei und geschmacklich wie ein Erfrischungsgetränk – kein bitteres Konzentrat.'
  ],
  biotics:['Everyday Biotics ist bei LiqVits in Entwicklung – auf Basis derselben flüssigen, hochbioverfügbaren Formel.']
};

const PRODUCTS_FULL = [
  { key:'vitamins', label:'Everyday Vitamins', colorHex:'#F0C233', soon:false,
    images:[IMG_LEMON, IMG_PEACH], ctaLabel:'Sichere Dir Deine Vitamins',
    url:VITAMINS_URL,
    coverage:'1 tägliche Portion deckt 100% des Tagesbedarfs (NRV) an allen 13 Vitaminen.',
    copy:{ high:'Deine Vitamin-Versorgung sieht aktuell solide aus — weiter so.',
           mid:'Booste Deine Vitaminversorgung und schließe genau die Lücken, die Du hast.',
           low:'Dein Alltag zehrt aktuell stark an Deinen Vitaminreserven.' } },
  { key:'minerals', label:'Everyday Minerals', colorHex:'#4A2E68', soon:false,
    images:[IMG_WILDBERRY, IMG_CHERRY], ctaLabel:'Sichere Dir Deine Mineralien',
    url:MINERALS_URL,
    coverage:'1 tägliche Portion deckt 100% des Tagesbedarfs (NRV) an allen 8 essenziellen Mineralien.',
    copy:{ high:'Deine Mineralstoff-Versorgung ist aktuell gut abgedeckt.',
           mid:'Booste Deine Mineralstoffversorgung und schließe genau die Lücken, die Du hast.',
           low:'Hoher Mineralstoffbedarf erkennbar — Deine Depots könnten leer sein.' } },
  { key:'biotics', label:'Everyday Biotics', colorHex:'#2F6B4F', soon:true,
    copy:{ high:'Deine Darmgesundheit scheint aktuell gut im Gleichgewicht.',
           mid:'Dein Darm könnte von gezielter Unterstützung profitieren.',
           low:'Deine Angaben deuten auf ein deutliches Darm-Ungleichgewicht hin.' } },
];
/* Biotics-Karte nur einbeziehen, wenn im Theme-Editor aktiviert (show_biotics). */
const PRODUCTS = SHOW_BIOTICS ? PRODUCTS_FULL : PRODUCTS_FULL.filter(p => !p.soon);

/* ============================================================
   FRAGEN, DIE IN DEN SCORE EINFLIESSEN (1–6)
   Mehrfachauswahl unbegrenzt (kein max-Cap) — Rmax wird dynamisch
   aus ALLEN Optionen berechnet. "Weiter" ist immer klickbar
   (Überspringen möglich, siehe Options-Handler weiter unten).
   ============================================================ */
const QUESTIONS = [
  { id:'geschlecht', tag:'Frage 1 von 7', title:'Was ist Dein Geschlecht?', type:'single', required:true,
    /* Fester, absoluter Bedarfsunterschied statt relativer Min-Max-Skala:
       Männlich = 0% Bedarf, Weiblich = +10% Bedarf, Divers = 5% (Mittelwert,
       da nicht separat definiert). Gilt einheitlich für alle Produkte. */
    needOverride:[10,0,5],
    options:['Weiblich','Männlich','Divers'],
    weights:{ vitamins:[8,7,7], minerals:[10,5,7], biotics:[5,7,6] },
    need:{
      vitamins:['Weil Du weiblich bist: Der Zyklus erhöht Deinen Bedarf an B-Vitaminen wie B6 & B12 spürbar.','Weil Du männlich bist: Auch bei Männern deckt die Ernährung oft nicht den vollen Tagesbedarf an Vitaminen.','Dein individueller Vitaminbedarf hängt von vielen Faktoren ab — wir schauen genauer hin.'],
      minerals:['Weil Du weiblich bist: Der Zyklus kostet Dich regelmäßig wichtige Mineralstoffe wie Eisen.','Weil Du männlich bist: Männer haben oft einen höheren Zinkbedarf als angenommen.','Dein Mineralstoffbedarf ist individuell — die richtige Versorgung lohnt sich trotzdem.'],
      biotics:['Ein ausgeglichenes Mikrobiom unterstützt auch den weiblichen Hormonhaushalt.','Ein stabiler Darm ist die Basis für Energie & Verdauung.','Deine Darmgesundheit ist unabhängig vom Geschlecht ein zentraler Baustein.']
    } },
  { id:'alter', tag:'Frage 2 von 7', title:'Wie alt bist Du?', type:'single',
    options:['Unter 25','25–34','35–44','45–54','Über 54'],
    weights:{ vitamins:[4,5,7,8,10], minerals:[3,4,7,8,7], biotics:[1,2,5,7,9] },
    need:{
      vitamins:['In jungen Jahren wird ein erhöhter Vitaminbedarf oft unterschätzt.','Stress & vollere Tage in Deiner Lebensphase erhöhen Deinen Vitaminverbrauch spürbar.','Ab Mitte 30 sinkt die Aufnahmefähigkeit vieler Vitamine langsam — Zeit, gegenzusteuern.','Ab 45 steigt Dein Bedarf an Vitaminen wie B12 spürbar an.','In Deiner Altersgruppe ist eine gezielte Vitaminversorgung besonders wichtig.'],
      minerals:['Auch jung profitierst Du von einer soliden Mineralstoffbasis für Energie & Konzentration.','In Deiner aktiven Lebensphase steigt Dein Mineralstoffbedarf spürbar.','Ab Mitte 30 lohnt sich ein genauerer Blick auf Deine Mineralstoffversorgung.','Ab 45 nimmt die Mineralstoffaufnahme über die Nahrung natürlicherweise ab.','In Deiner Altersgruppe ist der Mineralstoffbedarf besonders hoch.'],
      biotics:['Ein gesundes Mikrobiom legst Du am besten früh an.','Stressige Lebensjahre bringen die Darmflora leicht aus dem Gleichgewicht.','Ab Mitte 30 verändert sich Deine Darmflora zunehmend.','Ab 45 wird Deine Darmgesundheit ein noch wichtigerer Baustein.','In Deiner Altersgruppe verändert sich das Mikrobiom besonders stark.']
    } },
  { id:'ziele', tag:'Frage 3 von 7', title:'Was möchtest Du erreichen?', type:'multi',
    hint:'Wähle so viele Ziele aus, wie auf Dich zutreffen.',
    options:['Gesund bleiben','Mehr Energie','Fitter durch den Tag','Bessere Konzentration','Innere Balance','Langfristig gut fühlen','Unterstützung des Bindegewebes'],
    weights:{ vitamins:[10,7,7,8,2,8,9], minerals:[10,8,9,7,2,8,7], biotics:[3,2,3,5,15,8,2] },
    need:{
      vitamins:['Weil Du gesund bleiben willst: Vitamin C & D sind zentral für ein starkes Immunsystem.','Weil Du mehr Energie willst: Vitamine wie B6, B12 & Folsäure unterstützen direkt Deinen Energiestoffwechsel.','Weil Du fitter durch den Tag kommen willst: Ein aktiver Alltag verbraucht spürbar mehr Vitamine.','Weil Dir Konzentration wichtig ist: B-Vitamine tragen zu einer normalen kognitiven Funktion bei.','Weil Dir innere Balance wichtig ist: Eine stabile Vitaminversorgung ist dafür die Basis.','Weil Dir langfristiges Wohlbefinden wichtig ist: Eine stabile Vitaminversorgung ist die Basis, um das dauerhaft zu halten.','Weil Dir Dein Bindegewebe wichtig ist: Vitamin C ist unverzichtbar für die körpereigene Kollagenbildung.'],
      minerals:['Weil Du gesund bleiben willst: Zink & Selen unterstützen Dein Immunsystem.','Weil Du mehr Energie willst: Eisen & Mangan sind zentral für Deinen Energiestoffwechsel.','Weil Du fitter durch den Tag kommen willst: Eisen unterstützt Deine Sauerstoffversorgung und damit Deine Leistungsfähigkeit.','Weil Dir Konzentration wichtig ist: Zink & Jod unterstützen eine normale kognitive Funktion.','Weil Dir innere Balance wichtig ist: Zink trägt zu einer normalen kognitiven Funktion bei und unterstützt Dein inneres Gleichgewicht.','Weil Dir langfristiges Wohlbefinden wichtig ist: Zink & Selen unterstützen Dich dabei nachhaltig.','Weil Dir Dein Bindegewebe wichtig ist: Zink & Kupfer sind an der Kollagen- & Bindegewebsbildung beteiligt.'],
      biotics:['Ein gesunder Darm ist die Basis eines starken Immunsystems.','Deine Darmflora beeinflusst direkt, wie viel Energie Du hast.','Ein ausgeglichenes Mikrobiom unterstützt Deine Fitness im Alltag.','Die Darm-Hirn-Achse beeinflusst auch Deine Konzentration.','Dein Darm spielt eine zentrale Rolle für innere Balance.','Weil Dir langfristiges Wohlbefinden wichtig ist: Ein stabiler Darm ist die Basis für dauerhaftes Wohlbefinden.','Ein gesundes Mikrobiom unterstützt indirekt auch Dein Bindegewebe.']
    } },
  { id:'probleme', tag:'Frage 4 von 7', title:'Welche Probleme hast Du regelmäßig?', type:'multi',
    hint:'Wähle so viele Punkte aus, wie auf Dich zutreffen.',
    options:['Häufig krank','Öfters Stress','Ständig müde','Unausgeglichen','Magen-Darm-Unwohlsein','Hautprobleme','Keine wirklichen, einfach gesund fühlen'],
    weights:{ vitamins:[10,8,7,4,3,7,0], minerals:[10,8,10,5,3,10,0], biotics:[7,5,6,10,15,10,0] },
    need:{
      vitamins:['Weil Du häufig krank wirst: Das deutet oft auf einen erhöhten Vitamin-C- & D-Bedarf hin.','Weil Du öfters Stress hast: Das erhöht Deinen Verbrauch an B-Vitaminen deutlich.','Weil Du ständig müde bist: Das ist oft ein Zeichen für Vitaminmangel.','Weil Du Dich unausgeglichen fühlst: Das hängt oft mit dem B-Vitamin-Haushalt zusammen.','Weil Du Magen-Darm-Unwohlsein hast: Vitamine spielen für eine gesunde Verdauung eine wichtige Rolle.','Weil Du Hautprobleme hast: Vitamin A, C & Biotin sind wichtig für gesunde Haut.','Schön, dass Du Dich gut fühlst — eine gute Grundversorgung hilft Dir, das zu erhalten.'],
      minerals:['Weil Du häufig krank wirst: Zink ist zentral für ein starkes Immunsystem.','Weil Du öfters Stress hast: Zink & Selen werden bei Stress besonders schnell verbraucht.','Weil Du ständig müde bist: Ein Eisenmangel zeigt sich häufig genau so.','Weil Du Dich unausgeglichen fühlst: Zink trägt zu einer normalen kognitiven Funktion bei.','Weil Du Magen-Darm-Unwohlsein hast: Mineralstoffe unterstützen eine gesunde Darmfunktion.','Weil Du Hautprobleme hast: Zink spielt eine wichtige Rolle für die Hautgesundheit.','Schön, dass Du Dich gut fühlst — eine stabile Mineralstoffversorgung hilft Dir, das zu erhalten.'],
      biotics:['Ein Großteil Deines Immunsystems sitzt im Darm.','Stress wirkt sich direkt auf Dein Mikrobiom aus.','Ein unausgeglichener Darm kann Müdigkeit begünstigen.','Die Darm-Hirn-Achse beeinflusst auch Deine Stimmung.','Dieses Anliegen betrifft Deinen Darm ganz direkt.','Deine Darmflora hängt eng mit Deinem Hautbild zusammen.','Ein entspannter Darm ist die beste Basis, um das auch zu bleiben.']
    } },
  { id:'ernaehrung', tag:'Frage 5 von 7', title:'Wie ernährst Du Dich hauptsächlich?', type:'multi',
    hint:'Mehrfachauswahl möglich — wähle alles, was auf Dich zutrifft.',
    options:['Ausgewogen (Sehr umfangreich)','Viel Fleisch','Vegetarisch','Vegan','Viel Obst / Gemüse','Viel Nüsse / Körner','Öfters Fertigprodukte / Convenience Food','Viel am Snacken','Ausbaufähig'],
    weights:{ vitamins:[1,3,6,6,2,6,9,8,7], minerals:[1,2,8,10,3,3,9,8,7], biotics:[5,8,3,2,1,3,9,10,6] },
    need:{
      vitamins:['Auch bei ausgewogener, umfangreicher Ernährung schließen Vitamine oft kleine Lücken im Alltag.','Weil Du Dich fleischlastig ernährst: Tierische Lebensmittel liefern bereits eine solide Basis an B-Vitaminen.','Weil Du Dich vegetarisch ernährst: B12 kann bei pflanzenbetonter Ernährung leicht knapp werden.','Weil Du Dich vegan ernährst: B12 & Vitamin D brauchst Du fast immer gezielt zusätzlich.','Weil Du viel Obst & Gemüse isst: Das deckt viele, aber nicht alle Vitamine vollständig ab.','Weil Du viel Nüsse & Körner isst: Das liefert wichtige Vitamin-E-Quellen, aber selten das volle Spektrum aller 13 Vitamine.','Weil Du öfters zu Fertigprodukten greifst: Verarbeitete Lebensmittel enthalten meist deutlich weniger Vitamine als frische Zutaten.','Weil Du öfters snackst: Snacks liefern selten die Vitamine, die Dein Körper wirklich braucht.','Weil Deine Ernährung noch ausbaufähig ist: Eine gezielte Vitaminversorgung schließt zuverlässig die Lücken.'],
      minerals:['Auch bei ausgewogener, umfangreicher Ernährung bleiben oft kleine Mineralstofflücken.','Weil Du Dich fleischlastig ernährst: Das liefert Dir bereits eine solide Basis an Eisen & Zink.','Weil Du Dich vegetarisch ernährst: Eisen & Zink können knapp werden.','Weil Du Dich vegan ernährst: Eisen & Zink solltest Du im Blick behalten.','Weil Du viel Obst & Gemüse isst: Das liefert bereits einen guten Grundstock an Mineralstoffen.','Weil Du viel Nüsse & Körner isst: Das liefert bereits gute Mengen an Zink & Kupfer, aber selten alle 8 essenziellen Spurenelemente.','Weil Du öfters zu Fertigprodukten greifst: Verarbeitete Lebensmittel enthalten meist deutlich weniger Mineralstoffe als frische Zutaten.','Weil Du öfters snackst: Snacks enthalten meist kaum die Mineralstoffe, die Dein Körper braucht.','Weil Deine Ernährung noch ausbaufähig ist: Eine gezielte Mineralstoffversorgung schließt zuverlässig die Lücken.'],
      biotics:['Eine ausgewogene, umfangreiche Ernährung ist gut — Ballaststoffvielfalt zählt trotzdem.','Weil Du Dich fleischlastig ernährst: Das enthält oft wenig Ballaststoffe fürs Mikrobiom.','Weil Du Dich vegetarisch ernährst: Das unterstützt Deine Darmflora meist gut.','Weil Du Dich vegan ernährst: Das ist oft reich an Ballaststoffen für Deinen Darm.','Weil Du viel Obst & Gemüse isst: Ideal für eine gesunde Darmflora.','Weil Du viel Nüsse & Körner isst: Das ist eine hervorragende Ballaststoffquelle für Deine Darmflora.','Weil Du öfters zu Fertigprodukten greifst: Das bedeutet meist wenig Ballaststoffe für Deine Darmflora.','Weil Du öfters snackst: Zucker- und fettreiche Snacks können Deine Darmflora zusätzlich belasten.','Weil Deine Ernährung noch ausbaufähig ist: Mehr Vielfalt tut Deiner Darmflora gut.']
    } },
  { id:'aktivitaet', tag:'Frage 6 von 7', title:'Wie aktiv bist Du im Alltag?', type:'single',
    options:['Gar nicht / kaum aktiv','Sehr wenig aktiv','Wenig aktiv','Durchschnittlich aktiv','Viel aktiv','Sehr aktiv'],
    weights:{ vitamins:[3,3,3,5,6,7], minerals:[3,3,3,5,7,8], biotics:[9,8,7,5,4,3] },
    need:{
      vitamins:['Auch bei sehr wenig Bewegung lohnt sich eine solide Vitaminbasis.','Auch bei wenig Bewegung ist eine gute Vitaminversorgung sinnvoll.','Etwas mehr Bewegung erhöht Deinen Vitaminbedarf bereits leicht.','Bei durchschnittlicher Aktivität steigt Dein Vitaminbedarf spürbar.','Weil Du viel in Bewegung bist: Das erhöht Deinen Vitaminbedarf deutlich.','Weil Du körperlich stark gefordert bist: Das verlangt nach einer starken Vitaminversorgung.'],
      minerals:['Auch bei sehr wenig Bewegung ist eine stabile Mineralstoffversorgung wichtig.','Auch bei wenig Bewegung solltest Du Deine Mineralstoffversorgung im Blick behalten.','Etwas mehr Bewegung erhöht bereits Deinen Bedarf an Spurenelementen wie Zink & Eisen.','Bei durchschnittlicher Aktivität steigt Dein Bedarf an Spurenelementen spürbar.','Weil Du viel in Bewegung bist: Das führt zu einem höheren Verlust an Spurenelementen wie Eisen & Zink über den Schweiß.','Weil Du körperlich stark gefordert bist: Das erfordert eine starke Mineralstoffversorgung.'],
      biotics:['Bewegungsmangel kann sich negativ auf die Darmflora auswirken.','Auch bei wenig Bewegung profitiert Dein Darm von mehr Aktivität.','Etwas mehr Bewegung tut auch Deinem Darm gut.','Ein durchschnittlich aktiver Alltag wirkt sich positiv auf Dein Mikrobiom aus.','Ein aktiver Alltag unterstützt Dein Mikrobiom spürbar.','Sehr hohe Aktivität stellt besondere Anforderungen an Deinen Darm.']
    } },
];

/* ============================================================
   FRAGE 7 — fließt NICHT in den Bedarfs-Score ein, sondern liefert
   die persönliche "Warum LiqVits zu Dir passt"-Zeile. Getrennte
   Formulierungen pro Produkt, damit Vitamins- & Minerals-Karte
   nicht denselben Text zeigen. Unbegrenzte Mehrfachauswahl.
   ============================================================ */
const LIFESTYLE_QUESTION = {
  id:'lifestyle', tag:'Frage 7 von 7', title:'Wobei kann Dir LiqVits helfen?', type:'multi',
  hint:'Wähle so viele Punkte aus, wie auf Dich zutreffen.',
  options:['Zeit/Aufwand sparen','Eine einfache Lösung für alles, was mein Körper braucht','Mag keine Tabletten schlucken','Supplements die gut schmecken','Meine Supplements ersetzen','Ich möchte auch meine Kinder versorgen'],
  fitVitamins:[
    '5 Pumpstöße Everyday Vitamins genügen für Deinen kompletten Tagesbedarf an allen 13 Vitaminen — schneller geht’s nicht.',
    'Everyday Vitamins bündelt alle 13 Vitamine in einer Formel, statt mehrerer einzelner Präparate.',
    'Keine Kapseln nötig: Everyday Vitamins wird einfach in Dein Getränk gemischt.',
    'Everyday Vitamins schmeckt 1:1 wie Dein Lieblings-Softdrink — zuckerfrei und kalorienfrei.',
    'Viele ersetzen ihre bisherigen Vitamin-Tabletten komplett durch Everyday Vitamins — bei deutlich besserer Aufnahme.',
    'Everyday Vitamins lässt sich nach DGE-Empfehlung kinderleicht dosieren, z. B. 2 Pushs für 4–7-Jährige.'
  ],
  fitMinerals:[
    '5 Pumpstöße Everyday Minerals genügen für Deinen kompletten Tagesbedarf an allen 8 essenziellen Mineralien.',
    'Everyday Minerals bündelt alle 8 essenziellen Mineralien in einer Formel, statt mehrerer einzelner Präparate.',
    'Keine Kapseln nötig: Everyday Minerals wird einfach in Dein Getränk gemischt.',
    'Everyday Minerals schmeckt wie ein Erfrischungsgetränk — zuckerfrei und kalorienfrei, kein bitteres Konzentrat.',
    'Viele ersetzen ihre bisherigen Mineral-Präparate komplett durch Everyday Minerals — bei deutlich besserer Aufnahme.',
    'Everyday Minerals lässt sich nach DGE-Empfehlung kinderleicht dosieren, z. B. 2 Pushs für 4–7-Jährige.'
  ]
};

/* ============================================================
   WERTUNGSSYSTEM — grundlegend überarbeitet.
   Vorheriges Problem: Bei Mehrfachauswahl wurden die gewählten Gewichte
   SUMMIERT und gegen die Summe ALLER möglichen Gewichte verglichen. Das
   hat jede zusätzliche ehrliche Angabe automatisch bestraft — wer wenig
   anklickte (egal was), bekam praktisch immer ein besseres Ergebnis als
   jemand, der viele echte Punkte ehrlich ankreuzte.
   Neue Logik: Jede Frage liefert unabhängig von der Anzahl ihrer Optionen
   und unabhängig davon, WIE VIELE Antworten gewählt wurden, einen
   Bedarfswert von 0–100%:
     - Einfachauswahl: Bedarf = gewähltes Gewicht ÷ höchstmögliches
       Gewicht dieser Frage.
     - Mehrfachauswahl: Bedarf = DURCHSCHNITT der gewählten Gewichte ÷
       höchstmögliches Gewicht dieser Frage. Der Durchschnitt (statt der
       Summe) sorgt dafür, dass nur zählt, WIE SCHWER das Gewählte wiegt —
       nicht, wie viele Haken gesetzt wurden.
     - Übersprungene Frage: Bedarf = statistischer Durchschnitt ALLER
       Optionen dieser Frage — neutral, weder künstlich gut noch schlecht.
   Der Gesamt-Score ist der Durchschnitt der Bedarfswerte über alle 6
   scoring-relevanten Fragen, invertiert (100 − Bedarf), auf 15–100
   begrenzt. Jede Frage zählt damit gleich viel — unabhängig von Typ,
   Optionsanzahl oder Auswahlanzahl. So macht es z. B. immer einen klaren
   Unterschied, ob "Häufig krank" oder "Keine wirklichen Probleme"
   gewählt wird, und ehrliches, vollständiges Ausfüllen wird nie
   schlechter bewertet als minimales Anklicken.
   ============================================================ */
/* Manche Fragen sollen unterschiedlich stark in die Gesamtbewertung einfließen.
   Ziele fließt bewusst schwächer ein als die anderen 5 Fragen (Faktor 0.5 statt 1). */
const QUESTION_INFLUENCE = { geschlecht:1, alter:1, ziele:0.5, probleme:1, ernaehrung:1, aktivitaet:1 };

function questionNeedPct(q, productKey, ans){
  /* Manche Fragen (aktuell nur Geschlecht) haben einen fest definierten,
     absoluten Bedarfswert pro Option statt einer relativen Min-Max-Skala. */
  if(q.needOverride){
    if(!ans || ans.length===0){
      return q.needOverride.reduce((a,b)=>a+b,0) / q.needOverride.length;
    }
    return q.needOverride[ans[0]];
  }
  const w = q.weights[productKey];
  const maxW = Math.max(...w);
  const minW = Math.min(...w);
  const range = maxW - minW;
  let selectedAvg;
  if(!ans || ans.length===0){
    selectedAvg = w.reduce((a,b)=>a+b,0) / w.length;
  } else if(q.type==='single'){
    selectedAvg = w[ans[0]];
  } else {
    selectedAvg = ans.reduce((sum,i)=> sum + w[i], 0) / ans.length;
  }
  if(range === 0) return 50;
  return ((selectedAvg - minW) / range) * 100;
}

function calcScore(productKey, answers){
  let weightedSum = 0, influenceTotal = 0;
  QUESTIONS.forEach(q=>{
    const need = questionNeedPct(q, productKey, answers[q.id]);
    const infl = QUESTION_INFLUENCE[q.id] ?? 1;
    weightedSum += need * infl;
    influenceTotal += infl;
  });
  const avgNeed = weightedSum / influenceTotal;
  const s = 100 - avgNeed;
  return Math.round(Math.max(15, Math.min(100, s)));
}

function topReasons(productKey, answers){
  const pool = [];
  QUESTIONS.forEach(q=>{
    const ans = answers[q.id];
    if(!ans) return;
    ans.forEach(i=> pool.push({ weight:q.weights[productKey][i], need:q.need[productKey][i] }));
  });
  pool.sort((a,b)=> b.weight-a.weight);
  const seen = new Set(); const picked = [];
  for(const item of pool){
    if(seen.has(item.need)) continue;
    seen.add(item.need); picked.push(item.need);
    if(picked.length===3) break;
  }
  // Claims rotierend an die 3 wichtigsten Bedürfnisse anhängen
  const claims = CLAIMS[productKey] || [];
  return picked.map((need,i)=> claims.length ? `${need} ${claims[i % claims.length]}` : need);
}

function lifestyleFitFor(productKey, answers){
  const idxs = answers[LIFESTYLE_QUESTION.id];
  if(!idxs || !idxs.length) return null;
  const pool = productKey==='vitamins' ? LIFESTYLE_QUESTION.fitVitamins : LIFESTYLE_QUESTION.fitMinerals;
  // Vitamins nutzt die erste gewählte Antwort, Minerals die zweite (falls vorhanden) —
  // so zeigen beide Karten unterschiedliche, aber jeweils relevante Inhalte.
  const idx = productKey==='vitamins' ? idxs[0] : (idxs.length>1 ? idxs[1] : idxs[0]);
  return pool[idx];
}

function statusFor(score){
  if(score>=75) return {label:'Gut versorgt', cls:'high'};
  if(score>=45) return {label:'Empfehlenswert', cls:'mid'};
  return {label:'Sehr empfehlenswert', cls:'low'};
}

const mount = document.getElementById('questionsMount');
const answers = {};
let currentQ = -1;
const ALL_Q = [...QUESTIONS, LIFESTYLE_QUESTION];
const TOTAL_Q = ALL_Q.length;

ALL_Q.forEach((q,qi)=>{
  const step = document.createElement('div');
  step.className = 'step';
  step.dataset.step = 'q'+qi;

  const optsHtml = q.options.map((opt,oi)=>`
    <div class="opt ${q.type==='multi'?'multi':''}" data-i="${oi}">
      <div class="mark"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><path d="M5 13l4 4L19 7"/></svg></div>
      <span>${opt}</span>
    </div>`).join('');

  step.innerHTML = `
    <div class="q-tag">${q.tag}</div>
    <h2 class="q-title">${q.title}</h2>
    ${q.hint ? `<p class="q-hint">${q.hint}</p>` : ''}
    <div class="options">${optsHtml}</div>
    ${q.type==='multi' ? `<p class="multi-note"><b>0</b> ausgewählt</p>` : ''}
    <div class="cta-row"><button class="btn">Weiter
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
    </button></div>
  `;
  mount.appendChild(step);

  const optEls = [...step.querySelectorAll('.opt')];
  const nextBtn = step.querySelector('.btn');
  const noteEl = step.querySelector('.multi-note b');

  /* "Weiter" ist bei den meisten Fragen immer klickbar — so kann die Frage
     übersprungen werden, falls jemand sie nicht beantworten möchte oder kann.
     Als "required" markierte Fragen (aktuell nur Geschlecht) müssen jedoch
     erst beantwortet werden, bevor man weiterklicken kann. */
  if(q.required) nextBtn.disabled = true;

  optEls.forEach(el=>{
    el.addEventListener('click', ()=>{
      const i = parseInt(el.dataset.i);
      if(q.type==='single'){
        optEls.forEach(o=>o.classList.remove('selected'));
        el.classList.add('selected');
        answers[q.id] = [i];
        if(q.required) nextBtn.disabled = false;
      } else {
        el.classList.toggle('selected');
        const nowSelected = optEls.filter(o=>o.classList.contains('selected'));
        answers[q.id] = nowSelected.map(o=>parseInt(o.dataset.i));
        if(noteEl) noteEl.textContent = nowSelected.length;
      }
    });
  });

  nextBtn.addEventListener('click', ()=>{
    trackAnswer(q.id, answers[q.id]);
    goTo(qi+1);
  });
});

const allSteps = ()=> [
  {el:document.querySelector('[data-step="intro"]'), idx:-1},
  ...[...mount.children].map((el,i)=>({el, idx:i})),
  {el:document.querySelector('[data-step="results"]'), idx:TOTAL_Q},
];

function goTo(idx){
  currentQ = idx;
  allSteps().forEach(s=> s.el.classList.toggle('active', s.idx===idx));
  const progressRow = document.getElementById('progressRow');
  if(idx===-1){
    progressRow.classList.add('hidden');
  } else if(idx<TOTAL_Q){
    progressRow.classList.remove('hidden');
    document.getElementById('progressFill').style.width = ((idx+1)/TOTAL_Q*100)+'%';
    document.getElementById('progressCount').textContent = (idx+1)+' / '+TOTAL_Q;
  } else {
    progressRow.classList.add('hidden');
    renderResults();
  }
  window.scrollTo({top:0, behavior:'smooth'});
}

document.getElementById('startBtn').addEventListener('click', ()=>{
  startSession();
  goTo(0);
});
document.getElementById('backBtn').addEventListener('click', ()=>{
  if(currentQ>0) goTo(currentQ-1);
  else if(currentQ===0) goTo(-1);
});
document.getElementById('restartBtn').addEventListener('click', ()=>{
  Object.keys(answers).forEach(k=>delete answers[k]);
  [...mount.querySelectorAll('.opt')].forEach(o=>o.classList.remove('selected'));
  [...mount.querySelectorAll('.multi-note b')].forEach(n=> n.textContent='0');
  ALL_Q.forEach((q,qi)=>{ if(q.required) mount.children[qi].querySelector('.btn').disabled = true; });
  goTo(-1);
});

function subBlockHTML(p){
  return `
    <div class="reco-sub">
      <div class="result-top">
        <div class="result-name"><span class="dot" style="background:${p.colorHex}"></span>${p.label}</div>
        <span class="badge ${p.status.cls}">${p.status.label}</span>
      </div>

      <div class="bar-label"><span>${p.barLabel}</span><b style="color:${p.colorHex}">${p.score}%</b></div>
      <div class="bar-track"><div class="bar-fill" style="background:${p.colorHex}"></div></div>

      ${p.coverage ? `
      <div class="coverage-line" style="background:${p.colorHex}14;">
        <span class="coverage-check" style="background:${p.colorHex};"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.5"><path d="M5 13l4 4L19 7"/></svg></span>
        <span class="coverage-text" style="color:${p.colorHex==='#F0C233' ? '#8a6a12' : p.colorHex};">${p.coverage}</span>
      </div>` : ''}

      ${p.reasons.length ? `
      <div class="reasons-box">
        <div class="reasons-title">Deine Top 3 Unterstützung</div>
        ${p.reasons.map(r=>`
          <div class="reason-item">
            <span class="reason-check" style="background:${p.colorHex}22;">
              <svg viewBox="0 0 24 24" fill="none" stroke="${p.colorHex}" stroke-width="3.5"><path d="M5 13l4 4L19 7"/></svg>
            </span>
            <span>${r}</span>
          </div>`).join('')}
      </div>` : ''}

      ${p.fit ? `
      <div class="lifestyle-box">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l3 7h7l-5.5 4.5L18 21l-6-4-6 4 1.5-7.5L2 9h7z"/></svg>
        <span>${p.fit}</span>
      </div>` : ''}

      <div class="product-shots">
        <img src="${p.images[0]}" alt="${p.label}">
        <img src="${p.images[1]}" alt="${p.label}">
      </div>
      <p class="result-copy">${p.copy[p.status.cls]}</p>
    </div>`;
}

/* UTM-Parameter an Produkt-Links anhängen, damit Shopify Analytics
   Bestellungen, die über das Quiz kommen, als eigene Kampagne zeigt. */
function withUtm(url, content){
  const sep = url.includes('?') ? '&' : '?';
  return url + sep + 'utm_source=quiz&utm_medium=onsite&utm_campaign=was_brauche_ich&utm_content=' + content;
}

function comboHTML(vit,min){
  return `
    <div class="reco-section">
      <h2 class="reco-title">Deine Empfehlung</h2>
      <p class="reco-lead">Vitamins & Minerals ergänzen sich bei Dir besonders gut — deshalb empfehlen wir sie Dir als Set.</p>
      ${subBlockHTML(vit)}
      ${subBlockHTML(min)}
      <div class="reco-cta">
        <a href="${withUtm(STARTER_SET_URL,'bundle')}" class="btn dark full" style="text-decoration:none;" onclick="trackClick('bundle')">37% sparen für Vitamins+Minerals</a>
        <div class="reco-single-row">
          <a href="${withUtm(vit.url,'vitamins')}" class="btn light small" style="text-decoration:none;" onclick="trackClick('vitamins')">Nur Everyday Vitamins</a>
          <a href="${withUtm(min.url,'minerals')}" class="btn light small" style="text-decoration:none;" onclick="trackClick('minerals')">Nur Everyday Minerals</a>
        </div>
      </div>
    </div>`;
}

function bioticsCardHTML(p){
  return `
    <div class="result-card">
      <div class="result-top">
        <div class="result-name"><span class="dot" style="background:${p.colorHex}"></span>${p.label} <span style="font-family:Nunito;font-weight:700;color:var(--ink-soft);font-size:12.5px;">(bald verfügbar)</span></div>
        <span class="badge ${p.status.cls}">${p.status.label}</span>
      </div>

      <div class="bar-label"><span>${p.barLabel}</span><b style="color:${p.colorHex}">${p.score}%</b></div>
      <div class="bar-track"><div class="bar-fill" style="background:${p.colorHex}"></div></div>

      <div class="soon-shot">Everyday Biotics ist bei LiqVits in Entwicklung — melde Dich für den Launch an.</div>
      <button class="btn full" disabled>Bald bei LiqVits</button>
    </div>`;
}

/* ============================================================
   TRACKING — anonym, nur zur Auswertung/Routing-Kontrolle.
   API_BASE kommt aus der Section-Config; leeres Feld deaktiviert Tracking.

   Ablauf (wichtig für Abbrecher-Sichtbarkeit):
   1. startSession()   — beim Klick auf "Jetzt starten": legt die Session an.
   2. trackAnswer()    — bei JEDEM Klick auf "Weiter": speichert die Antwort
                          der jeweiligen Frage sofort, unabhängig vom Ausgang.
   3. completeSession()— beim Erreichen der Ergebnisseite: trägt die finalen
                          Scores in die bereits bestehende Zeile nach.
   ============================================================ */
const API_BASE = (LVCFG.apiBase !== undefined && LVCFG.apiBase !== null) ? LVCFG.apiBase : 'https://api.liqvits.com';
const QUIZ_VARIANT = SHOW_BIOTICS ? 'mit_biotics' : 'ohne_biotics';
const SESSION_ID = (crypto.randomUUID ? crypto.randomUUID()
  : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c=>{
      const r = Math.random()*16|0; return (c==='x'?r:(r&0x3|0x8)).toString(16);
    }));
let CURRENT_SUBMISSION_ID = null;
let SESSION_READY = null; // Promise, damit frühe trackAnswer()-Aufrufe nicht verloren gehen

function startSession(){
  if(!API_BASE) return; // Tracking im Theme-Editor deaktiviert (api_base leer gelassen)
  SESSION_READY = fetch(API_BASE + '/start-session.php', {
    method: 'POST',
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({ session_id: SESSION_ID, quiz_variant: QUIZ_VARIANT })
  }).then(r=>r.json()).then(res=>{
    if(res && res.success && res.submission_id){
      CURRENT_SUBMISSION_ID = res.submission_id;
      return res.submission_id;
    }
    return null;
  }).catch(()=> null);
}

function trackAnswer(questionId, selected){
  if(!API_BASE) return;
  const send = (id)=>{
    if(!id) return;
    fetch(API_BASE + '/track-answer.php', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ submission_id: id, question_id: questionId, selected: selected || [] })
    }).catch(()=>{ /* Tracking darf das Quiz-Erlebnis nie stören */ });
  };
  if(CURRENT_SUBMISSION_ID){ send(CURRENT_SUBMISSION_ID); }
  else if(SESSION_READY){ SESSION_READY.then(send); }
}

function completeSession(vit, min, bio){
  if(!API_BASE) return;
  const payload = {
    vitamins_score: vit.score, vitamins_status: vit.status.label,
    minerals_score: min.score, minerals_status: min.status.label
  };
  if(bio){ payload.biotics_score = bio.score; payload.biotics_status = bio.status.label; }

  const send = (id)=>{
    if(!id) return;
    payload.submission_id = id;
    fetch(API_BASE + '/complete-session.php', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(payload)
    }).catch(()=>{});
  };
  if(CURRENT_SUBMISSION_ID){ send(CURRENT_SUBMISSION_ID); }
  else if(SESSION_READY){ SESSION_READY.then(send); }
}

function trackClick(product){
  if(!API_BASE || !CURRENT_SUBMISSION_ID) return;
  const payload = JSON.stringify({ submission_id: CURRENT_SUBMISSION_ID, product });
  /* sendBeacon statt fetch: überlebt den Seitenwechsel, der durch den
     Klick auf den Link sofort ausgelöst wird — ein normaler fetch()
     könnte durch die Navigation abgebrochen werden, bevor er ankommt. */
  if(navigator.sendBeacon){
    navigator.sendBeacon(API_BASE + '/track-click.php', payload);
  } else {
    fetch(API_BASE + '/track-click.php', { method:'POST', headers:{'Content-Type':'application/json'}, body: payload, keepalive:true }).catch(()=>{});
  }
}

function renderResults(){
  const scored = PRODUCTS.map(p=>{
    const score = calcScore(p.key, answers);
    const barLabel = p.key==='vitamins' ? 'So gut bist Du jetzt an Vitaminen versorgt:'
                    : p.key==='minerals' ? 'So gut bist Du jetzt an Mineralien versorgt:'
                    : 'So gut ist Dein Darm jetzt versorgt:';
    return {...p, score, status: statusFor(score), barLabel,
            reasons: p.soon ? [] : topReasons(p.key, answers),
            fit: p.soon ? null : lifestyleFitFor(p.key, answers) };
  });

  const vit = scored.find(p=>p.key==='vitamins');
  const min = scored.find(p=>p.key==='minerals');
  const bio = scored.find(p=>p.soon);

  completeSession(vit, min, bio);

  /* Vitamins & Minerals werden immer gemeinsam als "Deine Empfehlung" gezeigt
     (gleiches Grundkonstrukt/gleiche Berechnung, nur andere Anordnung).
     Biotics bleibt eine eigene Karte und wird — wie bisher — je nach Dringlichkeit
     davor oder danach einsortiert. */
  const comboBlock = { order: Math.min(vit.score, min.score), html: comboHTML(vit,min), bars:[vit,min] };
  const blocks = bio
    ? [comboBlock, { order: bio.score, html: bioticsCardHTML(bio), bars:[bio] }].sort((a,b)=> a.order-b.order)
    : [comboBlock];

  document.getElementById('resultsMount').innerHTML = blocks.map(b=>b.html).join('');
  const barOrder = blocks.flatMap(b=>b.bars);
  requestAnimationFrame(()=>{
    document.querySelectorAll('.bar-fill').forEach((el,i)=>{
      setTimeout(()=>{ el.style.width = barOrder[i].score+'%'; }, 80*i);
    });
  });
}
